if (window.digitalDataProxy) {
	window.digitalDataProxy.captureGlobalEvents(document.body);
}
